export function getInStockStatus(part: any, requestedQty: number): "Y" | "N" {
    const hasPrice =
      part.list_price !== undefined && part.list_price !== null && part.list_price > 0;
      const stockQty = Number(part.stock) || 0;
  
    // Case 1: No price, but has stock
    if (!hasPrice && stockQty > 0) {
      return requestedQty <= stockQty ? "Y" : "N";
    }
  
    // Case 2: Has price, but no stock
    if (hasPrice && stockQty === 0) {
      return "N";
    }
  
    // Case 3: Has both price and stock
    if (hasPrice && stockQty > 0) {
      return "Y";
    }
  
    // Default fallback
    return "N";
  }
  export function isInStock(part: any): "Y" | "N" {
    return part?.stock && part.stock > 0 ? "Y" : "N";
  }
  
  export function getApproveFlag(part: any, requestedQty: number): 0 | 2 {
    // for in house part logic
    if (part?.lead_time_text === "In-House") {
      const hasPrice =
        part.list_price !== undefined && part.list_price !== null && Number(part.list_price) > 0;
      const stockQty = Number(part.stock) || 0;
      // Case 1: has price,  has stock
      if (hasPrice && stockQty > 0) {
        return stockQty >= requestedQty ? 0 : 2;
      } else {
        return 2;
      }
    }
    // for all parts logic
    else {
      return part?.lead_time &&
        part.lead_time > 0 &&
        part?.list_price &&
        part.list_price > 0
        ? 0
        : 2;
    }
  }

  // Build screen (RFQ from email) additions. approved=2 prints "Not currently
  // available" on the email, PDF and preview, so availability here is stock on
  // hand, never price or lead time (TICKET-23390). Short stock offers what is
  // on hand; the requested qty is kept so the shortfall note prints.
  export function buildScreenAvailability(
    stockQty: number | null | undefined,
    requestedQty: number,
    approvedYesValue: number
  ) {
    const onHand = Math.max(0, Number(stockQty) || 0);
    if (onHand === 0) {
      return {
        approved: 2,
        checked: 2,
        in_stock: "N",
        quantity: requestedQty,
        qty_requested: requestedQty,
        qty_responded: 0,
      };
    }
    const offered = Math.min(requestedQty, onHand);
    return {
      approved: approvedYesValue,
      checked: approvedYesValue,
      in_stock: "Y",
      quantity: offered,
      qty_requested: requestedQty,
      qty_responded: offered,
    };
  }

  // The approved/checked value that means "Yes": the key of "Y" in the quotes
  // config checked_list, 1 when unset.
  export function approvedYesValueFromConfig(quotesConfig: any): number {
    const checkedList = quotesConfig?.checked_list as
      | Record<string, string>
      | string[]
      | undefined;
    if (!checkedList) return 1;
    if (Array.isArray(checkedList)) {
      const idx = checkedList.findIndex((val) => String(val).toUpperCase() === "Y");
      return idx >= 0 ? idx : 1;
    }
    const entry = Object.entries(checkedList).find(
      ([, val]) => String(val).toUpperCase() === "Y"
    );
    if (entry) {
      const num = Number(entry[0]);
      return Number.isNaN(num) ? 1 : num;
    }
    return 1;
  }

  export function getQtyResponded(part: any, requestedQty: number) {
    // for in house part logic
    if (part?.lead_time_text === "In-House") {
      const hasPrice =
        part.list_price !== undefined && part.list_price !== null && part.list_price > 0;
      const stockQty = Number(part.stock) || 0;
  
      // Case 1: has price,  has stock
      if (hasPrice && stockQty > 0) {
        return stockQty >= requestedQty ? requestedQty : stockQty;
      }
  
      if (hasPrice && stockQty === 0) {
        return 0;
      }
  
      if (!hasPrice && stockQty > 0) {
        return stockQty >= requestedQty ? requestedQty : 0;
      }
    }
    // for all parts logic
    else {
      return part?.stock >= Number(requestedQty) ? requestedQty : part?.stock;
    }
  }
  
  export function getNotes(part: any, requestedQty: number) {
    // for in house part logic
    if (part?.lead_time_text === "In-House") {
      const hasPrice =
        part.list_price !== undefined && part.list_price !== null && part.list_price > 0;
      const stockQty = Number(part.stock) || 0;
  
      // Case 1: has price,  has stock
      if (hasPrice && stockQty > 0) {
        return stockQty >= requestedQty
          ? "currently in stock"
          : "waiting for availability a/o price";
      }
  
      if (hasPrice && stockQty === 0) {
        return "waiting for availability a/o price";
      }
  
      if (!hasPrice && stockQty > 0) {
        return stockQty >= requestedQty
          ? "out for quote."
          : "waiting for availability a/o price";
      }
    }
    else if(part?.flag){
      return "Unable to purchase at this time"
    }
    // for all parts logic
    else {
      return part?.stock >= Number(requestedQty)
        ? ""
        : part?.stock > 0 &&
          part?.lead_time > 0 &&
          part?.stock < Number(requestedQty)
        ? "Price is only valid for parts in inventory"
        : "";
    }
  }
  
/**
 * `sell_price` for POST /v6/quotes/raise_demand from a quote line's saved sell,
 * passed through unrounded so the sales order line matches the quote.
 * Returns undefined when there is no sell (0 is a sell), so the caller omits
 * `sell_price` and the server keeps its cost/line_discount fallback.
 */
export function quoteLineSellPrice(
  line: { sell?: number | string | null } | null | undefined
): number | string | undefined {
  const sell = line?.sell;
  if (sell === undefined || sell === null) {
    return undefined;
  }
  if (typeof sell === "string") {
    return sell.trim() === "" ? undefined : sell;
  }
  return Number.isFinite(sell) ? sell : undefined;
}
